import "./Qualities.scss";

import config from "../../../config";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode, Route } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import {
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_QUALITIES_DETAILS,
  ROUTE_WEIGHBILL,
} from "../../routes";
import {
  STORE_QUALITIES,
  SORT_ASC,
  SORT_DESC,
  QualitiesStore,
} from "../../Store/QualitiesStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import { BiCheck } from "react-icons/bi";

const SORT_ID = "Id";
const SORT_MACHINE = "Machine";
const SORT_CLEANINGRATE = "CleaningRateText";
const SORT_SUPPLIER = "Supplier";
const SORT_LOTNO = "LotNo";
const SORT_ITEM = "ItemName";
const SORT_LOCATION = "BinCode";
const SORT_AMOUNT = "Quantity";
const SORT_PURITY = "Purity";
const SORT_ALIENSEED = "Alienseed";
const SORT_HARDSEED = "Hardseed";
const SORT_GERM = "Germ";
const SORT_WATER = "Water";
const SORT_CREATED = "Created";
const SORT_TERMINATED = "Terminated";
const SORT_STATUS = "Status";
const SORT_WEIGHBILL = "WeighBill";
const SORT_LABID = "LabId";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_QUALITIES),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.searchtext.length > 0 ? "" : " hidden");
    return (
      <div className="table-search wide">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper wide">
          <input
            className="search-input"
            value={store.searchtext}
            onChange={(e) => store.setSearchText(e.target.value)}
          />
          <div
            className={cancelClassname}
            onClick={(e) => {
              store.setSearchText("");
              store.setSearch();
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        </div>
        <div
          className="btn searchbutton"
          onClick={(e) => {
            store.setSearch(store.searchtext);
          }}
        >
          Keres
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_QUALITIES),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Qualities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      showTerminated: false,
      from: null,
      to: null,
      subtable: null,
    };

    const now = new Date();
    const defaultFrom = new Date(now.setMonth(now.getMonth() - 3));

    const { store, type, route } = props;
    console.log("constructor", type, props.route.params);
    if (!route.params.hasOwnProperty("back")) {
      store.setSearch("");
      store.setSearchText("");
      store.setItems([]);
      store.setFrom(defaultFrom);
      store.setTo(null);
    }
    if (!store.from) store.setFrom(defaultFrom);
    store.resetCheckedPallets();
    store.setType(type);
    if (store.type) this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField[0] === field || store.sortField[1] === field) {
      store.flipSortDirection(field);
    } else {
      store.setSortField(field);
      store.setSortDirection(field, SORT_ASC);
    }
  };

  onFileChange = async (e) => {
    const { store } = this.props;
    if (!e.target.files.length || store.uploading) return;
    const data = new FormData();
    data.append("file", e.target.files[0]);
    e.target.value = "";
    store.setUploading();
    try {
      const response = await axios.post(config.FILE_UPLOAD_URL(window), data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.setState({
        popup: "show",
        popupText: "Sikeres minőség feltöltés (" + response + " db).",
      });
    } catch (e) {
      console.error("feltöltés hiba: ", e);
      this.setState({
        popup: "show",
        popupText: "Sikertelen minőség feltöltés.",
      });
    } finally {
      store.setUploading(false);
      this.refresh();
    }
  };

  handleDownload() {
    const { store, configStore } = this.props;
    const { sortedItems, qualitytypes } = store;

    const header = [
      "Azonosító",
      "Gép",
      "Fok",
      "Beszállító",
      "Cikk",
      "Hely",
      "Mennyiség",
      "Összmennyiség",
      "Létrehozva",
    ];

    qualitytypes.forEach((qualityname) => {
      header.push(qualityname.text);
    });

    const merges = [];
    let data = [header];

    let rowindex = 1;

    sortedItems.forEach((pallet) => {
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        pallet.MachineText,
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        (pallet.Supplier ? pallet.Supplier : "") +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : ""),
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode
          ? pallet.BinCode + (pallet.Level != null ? "/" + pallet.Level : "")
          : "",
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.BagCount * pallet.Quantity,
        pallet.Created,
      ];

      qualitytypes.forEach((qualityname) => {
        const value = pallet[qualityname.name] || "";
        row.push({
          t: isNaN(value) ? "s" : "n",
          v: value,
        });
      });

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Táblázat");

    XLSX.writeFile(wb, "Táblázat_" + formatDateOnly(new Date()) + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  }

  refresh() {
    const { store, socket } = this.props;

    const data = {
      From: store.from ? store.fromFormatted : null,
      To: store.to ? store.toFormatted : null,
      Type: store.type,
    };

    const _this = this;
    socket.emitWithToken("GetQualities", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  }

  setPalletHistory(palletid) {
    const { socket } = this.props;

    if (
      this.state.palletHistory &&
      this.state.palletHistory.palletId === palletid
    ) {
      this.setState({ palletHistory: null });
    } else {
      const _palletid = palletid;
      const _this = this;

      socket.emitWithToken(
        "GetPalletHistory",
        { PalletId: _palletid },
        function (err, data) {
          if (err) {
            console.error(err);
            return;
          }
          _this.setState({
            palletHistory: { palletId: _palletid, pallets: data },
          });
        }
      );
    }
  }

  componentDidMount() {
    const { route, store, socket } = this.props;
    if (route.params.hasOwnProperty("search")) {
      store.setSearch(route.params.search);
    }

    socket.on("InventoryChanged", this.inventoryChanged);

    this.props.socket.emitWithToken(
      "GetSealnums",
      {},
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        store.setSealnums(data);
      },
      store
    );
  }

  componentWillUnmount() {
    this.props.socket.off("InventoryChanged", this.inventoryChanged);
  }

  inventoryChanged = (data) => {
    if (data && data.UserId == authStore.user.Id) return;
    this.setState({ newContentAvailable: true });
  };

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  filterPallet = (pallet) => {
    const { store } = this.props;
    const item = pallet.ItemName + " " + (pallet.CustomItem || "");
    const machine = pallet.MachineText;
    const cleaningrate =
      pallet.CleaningRateText + " " + (pallet.CustomCleaningRate || "");
    const supplier = pallet.Supplier + " " + (pallet.CustomSupplier || "");
    store.setSearchText(
      item + " " + machine + " " + cleaningrate + " " + supplier
    );
    store.setSearch(store.searchtext);
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;

    let rows = [];

    const permissionlevel = authStore.user
      ? authStore.user.PermissionLevel
      : null;

    console.log(store.sortField[0], store.sortField[1]);
    console.log(store.sortDirection[0], store.sortDirection[1]);

    shownItems.forEach((pallet) => {
      rows.push(
        <tr
          key={pallet.Id}
          className="qualitytable__pallet-row"
          onClick={() => {
            store.resetCheckedPallets();
            this.filterPallet(pallet);
          }}
        >
          <td
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div
              className="table-checkbox-block"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <input
                id={"checkpallet" + pallet.Id}
                type="checkbox"
                name="checkedPallet"
                value="checkedPallet"
                checked={store.isChecked(pallet.Id)}
                onClick={(e) => {
                  store.setChecked(pallet.Id, !store.isChecked(pallet.Id));
                }}
              />
              <label htmlFor={"checkpallet" + pallet.Id}>
                <span></span>
              </label>
            </div>
          </td>
          <td>
            <div
              className="table_inrow_button"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                store.setSelectedPallets([pallet.Id]);
                router.navigate(ROUTE_QUALITIES_DETAILS);
              }}
            >
              Részletek
            </div>
          </td>

          {store.type === "processed" && <td>{pallet.LabId}</td>}
          {store.type === "raw" && (
            <td>
              {pallet.WeighBill &&
              (permissionlevel === 1 || permissionlevel === 11) ? (
                <div
                  className="table_inrow_button"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    store.setSelectedWeighBill(pallet.WeighBill);
                    router.navigate(ROUTE_WEIGHBILL);
                  }}
                >
                  {pallet.WeighBill}
                </div>
              ) : (
                pallet.WeighBill
              )}
            </td>
          )}

          <td
            className="table-cell-active"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              this.setPalletHistory(pallet.Id);
            }}
          >
            <span
              className={
                (pallet.CleaningCount > 1 ? "bold" : "normal") +
                (!pallet.ThisSeason ? " offseasonpallet" : "")
              }
            >
              {pallet.LotNo}
            </span>
            {pallet.SealNum ? <br /> : null}{" "}
            {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
          </td>
          <td>
            <span>
              {pallet.MachineText} {pallet.Dressing ? <br /> : null}{" "}
              {pallet.Dressing ? "(" + pallet.Dressing + ")" : null}
            </span>
          </td>
          <td>
            {pallet.CleaningRateText}
            {pallet.CustomCleaningRate ? <br /> : null}
            {pallet.CustomCleaningRate
              ? "(" + pallet.CustomCleaningRate + ")"
              : ""}
          </td>
          <td>
            {pallet.Supplier +
              (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : "")}
          </td>
          <td>
            {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
            {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
          </td>
          <td>
            {(pallet.BagType === 2
              ? pallet.BagCount + " x " + pallet.Quantity
              : pallet.Quantity) + " kg"}
          </td>
          <td>{pallet.QualityPurity ? pallet.QualityPurity + " %" : ""}</td>
          <td>{pallet.QualityGerm ? pallet.QualityGerm + " %" : ""}</td>
          <td>{pallet.QualityWater ? pallet.QualityWater + " %" : ""}</td>
          <td>{pallet.Created}</td>
        </tr>
      );

      if (
        this.state.palletHistory &&
        this.state.palletHistory.palletId === pallet.Id
      ) {
        const history = this.state.palletHistory;
        rows.push(
          <tr
            className="subtable"
            key={"s" + history.palletId}
            id={"s" + pallet.Id}
          >
            <table>
              <tr>
                <th>Gép</th>
                <th>Fok</th>
                <th>Mennyiség</th>
                <th>Tisztaság</th>
                <th>Idegenmag</th>
                <th>Keménymag</th>
                <th>Csíra</th>
                <th>Víz</th>
                <th>Létrehozva</th>
                <th>Megszüntetve</th>
              </tr>
              {history.pallets.map((historyPallet) => {
                return (
                  <tr>
                    <td>
                      {configStore.machines[historyPallet.MachineId].Name +
                        (historyPallet.CleaningCount
                          ? " x" + historyPallet.CleaningCount
                          : "")}
                      {historyPallet.Dressing ? <br /> : null}{" "}
                      {historyPallet.Dressing
                        ? "(" + historyPallet.Dressing + ")"
                        : ""}
                    </td>
                    <td>
                      {
                        configStore.cleaningRates[
                          historyPallet.CleaningRate
                        ].split("-")[0]
                      }
                    </td>
                    <td>
                      {historyPallet.BagType === 2
                        ? historyPallet.BagCount +
                          " x " +
                          historyPallet.Quantity
                        : historyPallet.Quantity}{" "}
                      kg
                    </td>
                    <td>
                      {historyPallet.QualityPurity
                        ? historyPallet.QualityPurity + " %"
                        : ""}
                    </td>
                    <td>
                      {historyPallet.QualityAlienseed
                        ? historyPallet.QualityAlienseed == -1.0
                          ? "Ny"
                          : historyPallet.QualityAlienseed + " %"
                        : ""}
                    </td>
                    <td>
                      {historyPallet.QualityHardseed
                        ? historyPallet.QualityHardseed + " %"
                        : ""}
                    </td>
                    <td>
                      {historyPallet.QualityGerm
                        ? historyPallet.QualityGerm + " %"
                        : ""}
                    </td>
                    <td>
                      {historyPallet.QualityWater
                        ? historyPallet.QualityWater + " %"
                        : ""}
                    </td>
                    <td>{formatDate(historyPallet.Created)}</td>
                    <td>
                      {historyPallet.Terminated
                        ? formatDate(historyPallet.Terminated)
                        : null}
                    </td>
                  </tr>
                );
              })}
            </table>
          </tr>
        );
      }
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <div className="table-datepicker-block">
              Létrehozva&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>

            <TableSearch />
            <div className="table-upload">
              <label
                className={"btn table-upload__btn btn--upper btn--large"}
                onClick={() => this.handleDownload()}
              >
                excel letöltés
              </label>
            </div>
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  <th className="table-header-checkbox">
                    <div
                      className="table-header-delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        store.setCheckedAll();
                      }}
                    >
                      <BiCheck size={20} />
                    </div>

                    <div
                      className="table-header-delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        store.resetCheckedPallets();
                      }}
                    >
                      X
                    </div>
                  </th>
                  <th>
                    <div
                      className={
                        "table_inrow_button " +
                        (store.checked.length > 0 ? "" : " disabled")
                      }
                      onClick={() => {
                        store.setSelectedPallets(store.checked);
                        router.navigate(ROUTE_QUALITIES_DETAILS);
                      }}
                    >
                      Részletek
                    </div>
                  </th>

                  {store.type === "processed" && (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_LABID)}
                      >
                        Labor sorszám
                        <Sorter
                          activeDirection={
                            sortField === SORT_LABID ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  )}

                  {store.type === "raw" && (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_WEIGHBILL)}
                      >
                        Mérlegjegy
                        <Sorter
                          activeDirection={
                            sortField === SORT_WEIGHBILL ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  )}

                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOTNO)}
                    >
                      Azonosító
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOTNO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_MACHINE)}
                    >
                      Gép
                      <Sorter
                        activeDirection={
                          sortField === SORT_MACHINE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CLEANINGRATE)}
                    >
                      Fok
                      <Sorter
                        activeDirection={
                          sortField === SORT_CLEANINGRATE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_SUPPLIER)}
                    >
                      Beszállító
                      <Sorter
                        activeDirection={
                          sortField === SORT_SUPPLIER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_PURITY)}
                    >
                      Tisztaság
                      <Sorter
                        activeDirection={
                          sortField === SORT_PURITY ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_GERM)}
                    >
                      Csíra
                      <Sorter
                        activeDirection={
                          sortField === SORT_GERM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_WATER)}
                    >
                      Víz
                      <Sorter
                        activeDirection={
                          sortField === SORT_WATER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CREATED)}
                    >
                      Létrehozva
                      <Sorter
                        activeDirection={
                          sortField === SORT_CREATED ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  {store.showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_TERMINATED)}
                      >
                        Megszüntetve
                        <Sorter
                          activeDirection={
                            sortField === SORT_TERMINATED ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                  {store.showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_STATUS)}
                      >
                        Művelet
                        <Sorter
                          activeDirection={
                            sortField === SORT_STATUS ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_STATUS,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_PURITY,
  SORT_ALIENSEED,
  SORT_HARDSEED,
  SORT_GERM,
  SORT_WATER,
  SORT_LABID,
  SORT_WEIGHBILL,
};

export default (props) => (
  <Route>{({ route }) => <Qualities route={route} {...props} />}</Route>
);
